import { createAction } from "redux-act";

export const InfoOpenModalAction = createAction("Info - Open Modal");
export const InfoCloseModalAction = createAction("Info - Close Modal");
